<template>
  	<div id="app">
		<app-header></app-header>
		<div id="wrapper" class="app-sidebar-right">
            <app-sidebar></app-sidebar>
            <router-view></router-view>
        </div>
  	</div>
</template>

<script>
	import "@babel/polyfill";
    import Header from '@/components/partials/Header';    
    import Footer from '@/components/partials/Footer';
    import Sidebar from '@/components/partials/Sidebar';
	import EventBus from '../../frontend/src/components/event-bus';
	var contex;
	export default {
		components: {
            'app-header': Header,
            'app-footer': Footer,
            'app-sidebar': Sidebar,
        },
		name: 'App',
		data: () => ({
            showHeader: true,
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
        },

        methods : {

        }
	}
</script>

<style>
	@import '../node_modules/@syncfusion/ej2-base/styles/material.css';
	@import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
	@import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
	@import '../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
	@import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
</style>



// WEBPACK FOOTER //
// src/App.vue